// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const IndustrySlice = zod.object({
  "count": zod.int(),
  "id": zod.union([zod.uuid(),zod.null()]),
  "key": zod.string(),
  "name": zod.string()
});

export type IndustrySlice = zod.input<typeof IndustrySlice>;
export type IndustrySliceOutput = zod.output<typeof IndustrySlice>;
